import '../styles/PageGlobal.css';
import './TVAListPage.css';
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ReferenceButton from '../components/ReferenceButton';
import { TVAService } from '../services/TVAService.js';
import { ImportService } from '../services/ImportService.js';
import { ExportService } from '../services/ExportService.js';

export default function TVAListPage() {
  const navigate = useNavigate();
  const [lignes, setLignes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

    const importService = useMemo(() => new ImportService(), []);
  const exportService = useMemo(() => new ExportService(), []);

  const fetchTVA = useCallback(async () => {
    const service = new TVAService();
    setLoading(true);
    try {
      const data = await service.getAllTVA();
      setLignes(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchTVA(); }, [fetchTVA]);

  const handleDelete = async (id) => {
    if (!window.confirm("Confirmer la suppression de cette référence TVA ?")) return;
    try {
      await new TVAService().deleteTVA(id);
      fetchTVA();
    } catch (err) {
      alert(err.message);
    }
  };

    const handleDeleteAll = async () => {
    if (!window.confirm("️ ATTENTION : Cela va supprimer DÉFINITIVEMENT toutes les références TVA. Continuer ?")) return;
    try {
      const message = await new TVAService().deleteAllTVA();
      alert(message);
      fetchTVA();
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="tva-error">{error}</div>;

   

   const handleImportTVA = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      try {
        const message = await importService.importTVA(file);
        alert(message);
        fetchTVA(); // Rafraîchir la liste
      } catch (err) {
        alert("Erreur d'import : " + err.message);
      }
    };
    input.click();
  };

  const handleExportTVA = async () => {
    try {
      const blob = await exportService.exportTVA();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'tva_export.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      alert("Erreur d'export : " + err.message);
    }
  };


  return (
    <div className="containerMain tva-container">
      <h1 className="tva-title">TVA</h1>
      <p className="tva-subtitle">Ceci est un contenu protégé</p>

      <div className="tva-top-actions">
        <ReferenceButton onClick={handleImportTVA}>Import des TVA</ReferenceButton>
        <ReferenceButton onClick={handleExportTVA}>Export des TVA</ReferenceButton>
        <button className="tva-btn tva-btn-red" onClick={handleDeleteAll} style={{ fontWeight: 'bold' }}>
      ️ Supprimer TOUTES les TVA
    </button>
      </div>

      <div className="tva-table-wrapper">
        <table className="tva-table">
          <thead>
            <tr>
              <th>N</th>
              <th>Référence Produit</th>
              <th>Code Douane</th>
              <th>OM (%)</th>
              <th>DA (%)</th>
              <th>TVA (%)</th>
              <th>État (Pays)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {lignes.map((ligne, index) => (
              <tr key={ligne.id}>
                <td>{index + 1}</td>
                <td className="tva-ref">{ligne.produitReference || ''}</td>
                <td>{ligne.codeDouane || ''}</td>
                <td>{ligne.ddomRate != null ? ligne.ddomRate.toFixed(2) + ' %' : '-'}</td>
                <td>{ligne.daRate != null ? ligne.daRate.toFixed(2) + ' %' : '-'}</td>
                <td>{ligne.tvaRate != null ? ligne.tvaRate.toFixed(2) + ' %' : '-'}</td>
                <td>{ligne.tvaState?.label || '-'}</td>
                <td className="tva-action-cell">
                  <button className="tva-btn tva-btn-yellow" onClick={() => navigate(`/tva_edit/${ligne.id}`)}>Edit</button>
                  <button className="tva-btn tva-btn-red" onClick={() => handleDelete(ligne.id)}>Suppr.</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="tva-bottom-actions">
        <ReferenceButton to="/tva_new">Nouvelle référence</ReferenceButton>
      </div>
    </div>
  );
}